module.exports = __webpack_public_path__ + "static/6-6cd9ac72c406009b805f6043bddcafff.jpeg";